/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromotionalLinkModel } from '../../models/promotional-link-model';

export interface PromotionalLinkPromotionalLinkPost$Params {
      body?: PromotionalLinkModel
}

export function promotionalLinkPromotionalLinkPost(http: HttpClient, rootUrl: string, params?: PromotionalLinkPromotionalLinkPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<PromotionalLinkModel>> {
  const rb = new RequestBuilder(rootUrl, promotionalLinkPromotionalLinkPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<PromotionalLinkModel>;
    })
  );
}

promotionalLinkPromotionalLinkPost.PATH = '/PromotionalLink/PromotionalLink';
